import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonProps", "buttonComponent", "loading", "failed", "label", "metadata", "onAuthSucceeded", "onAuthCancelled", "url"];
import { useEffect, useCallback } from 'react';
import I18n from 'I18n';
import enviro from 'enviro';
import { getAbsoluteReconnectUrl } from '../../utils/urlUtils';
import { useAuthorizeUberconference } from './hooks/useAuthorizeUberconference';
import { BasicReconnectButton } from '../../components/reconnectButton/BasicReconnectButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const UberconferenceReconnectButton = _ref => {
  let {
      buttonProps,
      buttonComponent,
      loading: propsLoading,
      failed: propsFailed,
      label,
      metadata,
      onAuthSucceeded,
      onAuthCancelled,
      url
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    authorizeAccount,
    updating,
    error: updatingError
  } = useAuthorizeUberconference();
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  const handleAuthFailed = useCallback(errorData => {
    if (enviro.isQa()) {
      console.error('Reconnection failed with error:', errorData);
    }
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled(errorData);
  }, [onAuthCancelled]);
  const handleAuthSucceeded = code => {
    void authorizeAccount(code).then(() => {
      if (!updatingError) {
        onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
      }
    });
  };
  useEffect(() => {
    if (updatingError) {
      handleAuthFailed({
        error: updatingError,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    }
  }, [updatingError, handleAuthFailed]);
  const updatedButtonProps = Object.assign({}, buttonProps, {
    disabled: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled) || updating
  });
  const isLoading = propsLoading || updating;
  const isFailed = propsFailed || !!updatingError;
  const authUrl = getAbsoluteReconnectUrl({
    urlTemplate: url,
    appId,
    accountId
  });
  return /*#__PURE__*/_jsx(BasicReconnectButton, Object.assign({
    buttonProps: updatedButtonProps,
    buttonComponent: buttonComponent,
    loading: isLoading,
    failed: isFailed,
    "data-test-id": "uberconference-reconnect-button",
    label: label || I18n.text('reconnect.buttons.reconnect'),
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: handleAuthFailed,
    url: authUrl
  }, otherProps));
};